<template>
  <div id="">
    <energy-organize @changeNode="changeNode" :treeData='treeData' @setTree='setTree'></energy-organize>
    <div class="content">
      <div class="top">
        <my-date-picker @changeTime="changeTime2" :type="2"></my-date-picker>
      </div>
      <div class="table-box">
        <div class="title">
          <div>环比报表
            <span v-if="timeArr.length>0&&dateType!=3">（ {{timeArr[0]}}至{{timeArr[1]}} ）</span>
            <span v-if="timeArr.length>0&&dateType==3">（ {{timeArr[0]}} ）</span>
            <span @click="exportLog" id="exportLog" class="exportLog-btn">导出</span>
          </div>
        </div>

        <div class="company-list clearfix">
          <ul class="list-title" style="position: relative; top: 25px; width: 97.6%;">
            <li class="w-40">序号</li>
            <li class="w-20">设备名称</li>
            <!-- <li>时间</li> -->
            <li class="t-right">上期用电量(kW·h)</li>
            <li class="t-right">本期用电量(kW·h)</li>
            <li class="t-right">增加量(kW·h)</li>
            <li class="t-right">环比(%)</li>
            <li class="w-40"></li>
          </ul>
          <div class="scroll">
            <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
              <li class="w-40">{{i+1}}</li>
              <li class="w-20">{{item.name}}</li>
              <!-- <li :title="changeTime(Number(item.time))">{{changeTime(Number(item.time))}}</li> -->
              <li class="t-right">{{item.previous!=null?fmoney(item.previous):'--'}}</li>
              <li class="t-right">{{item.current!=null?fmoney(item.current):'--'}}</li>
              <li class="t-right">{{item.increment!=null?fmoney(item.increment):'--'}}</li>
              <li class="t-right">{{item.ratio!=null?floatMultiply(item.ratio ,1).toFixed(2):'--'}}</li>
              <li class="w-40"></li>
            </ul>
          </div>
        </div>
        <!-- 没有列表数据 -->
        <div class="nullDataBox" v-show="dataList.length==0">
          <img :src="nullData" class="nullData">
          <span>什么东西都没有找到...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import energyOrganize from "../PublicAssembly/EnergyOrganize.vue"
  import myDatePicker from "../PublicAssembly/MyDatePicket.vue"
  import Pagination from "@/components/PublicAssembly/pagination"
  var XLSX = require('xlsx')
  export default {
    data() {
      return {
        timeArr: [],
        dataList: [],
        dateType:null,
        nullData: require('@/assets/image/index/nullData.png'),
        exportLogUrl: '',
        treeData:[],
        treeObj:{}
      }
    },
    components: {
      energyOrganize,
      myDatePicker,
      Pagination
    },
    computed:{
      /**
       * 将科学计数法的数字转为字符串
       * 说明：运算精度丢失方法中处理数字的时候，如果出现科学计数法，就会导致结果出错
       * 4.496794759834739e-9  ==> 0.000000004496794759834739
       * 4.496794759834739e+9  ==> 4496794759.834739
       * @param  num
       */
      toNonExponential() {
        return (num) => {
          if (num == null) {
            return num;
          }
          if (typeof num == "number") {
            var m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
            return num.toFixed(Math.max(0, (m[1] || '').length - m[2]));
          } else {
            return num;
          }
        }
      },


      /**
       * 乘法 - js运算精度丢失问题
       * @param arg1  数1
       * @param arg2  数2
       * 0.0023 * 100 ==> 0.22999999999999998
       * {{ 0.0023 | multiply(100) }} ==> 0.23
       */
      floatMultiply() {
        return (arg1, arg2) => {
          arg1 = Number(arg1);
          arg2 = Number(arg2);
          if ((!arg1 && arg1 !== 0) || (!arg2 && arg2 !== 0)) {
            return null;
          }
          arg1 = this.toNonExponential(arg1);
          arg2 = this.toNonExponential(arg2);
          var n1, n2;
          var r1, r2; // 小数位数
          try {
            r1 = arg1.toString().split(".")[1].length;
          } catch (e) {
            r1 = 0;
          }
          try {
            r2 = arg2.toString().split(".")[1].length;
          } catch (e) {
            r2 = 0;
          }
          n1 = Number(arg1.toString().replace(".", ""));
          n2 = Number(arg2.toString().replace(".", ""));
          return n1 * n2 / Math.pow(10, r1 + r2);
        }
      },
    },
    created() {
      this.$store.state.energyIndex = '/Energy/RatioReport'
      this.getTree()
    },
    methods: {
      // 获取组织树
      getTree() {
        let data = {
          companyId: this.$store.state.companyId,
          type: 1
        }
        this.get('/EnergyGroup/getTree', data).then(res => {
          if (res.success) {
            this.treeData = res.result
          } else {
            this.$message({
              type: 'warning',
              message: `获取组织树数据失败：${res.message}`
            })
          }
        })
      },
      // 更新树节点
      changeNode(data) {
        this.treeId = data.id
        this.treeObj =data
        this.getList()
      },
      setTree(data){
        this.treeData=data
        this.$forceUpdate()
      },
      // 获取列表
      getList(){
        if(!this.treeId&&this.treeId!=0||this.timeArr.length==0){
          return
        }
          let data = {
            companyId: this.$store.state.companyId,
            groupId: this.treeId,
            groupType: 1,
            timeType:this.dateType,
            time:new Date(this.timeArr[0] + " 0:0:0").getTime()
          }
        this.get('/EnergyReport/getRatioReport', data).then(res => {
          if (res.success) {
            this.dataList = res.result
          } else {
            this.$message({
              type: 'warning',
              message: `获取列表数据失败：${res.message}`
            })
          }
        })

      },
      changeTime2(v,type) {
        if (v) {
          this.timeArr = v
          this.dateType = type
          this.getList()
        }
      },
      // 导出日志
      exportLog() {
        // 创建表格
        var wb = XLSX.utils.book_new();
        let titleArr=['序号','设备名称','本期用电量(kW·h)','上期用电量(kW·h)','增加量(kW·h)','环比(%)'],dataArr=[]
        dataArr.push(titleArr)
        for(let i in this.dataList){
          let valuearr=[]
          valuearr.push(i+1)
          valuearr.push(this.dataList[i].name)
          // valuearr.push(this.changeTime(this.dataList[i].time))
          valuearr.push(this.dataList[i].previous!=null?Number(this.dataList[i].previous):'')
          valuearr.push(this.dataList[i].current!=null?Number(this.dataList[i].current):'')
          valuearr.push(this.dataList[i].increment!=null?Number(this.dataList[i].increment):'')
          valuearr.push(this.dataList[i].ratio!=null?(Number(this.dataList[i].ratio)*100).toFixed(2):'')
          dataArr.push(valuearr)
          var obj = {
            name : this.dataList[i].name,
            dataArr:dataArr,
          }
        }
          var ws = XLSX.utils.aoa_to_sheet(dataArr);
          XLSX.utils.book_append_sheet(wb, ws,'环比报表 '+this.timeArr[0]+'至'+this.timeArr[1]);
        // console.log(obj)
        XLSX.writeFile(wb, this.changeTime(new Date().getTime()) + '.xlsx');
      },
    }
  }
</script>

<style scoped>
  .company-list {
    overflow: hidden;
    margin-bottom: 32px;
    margin-top: 15px;
  }

  .scroll {
    overflow: auto;
    width: 97.6%;
    height: 630px;
    max-height: 630px !important;
    box-sizing: border-box;
    border: 1px solid #f2f2f2;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    margin-top: 24px;
  }

  /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
  .list-title,
  .list-details {
    display: flex;
    justify-content: space-around;
    line-height: 44px;
    font-size: 14px;
    color: #636363;
  }

  .list-title {
    background: #eeeeee;
  }

  .list-title li,
  .list-details li {
    width: 200px;
    margin: 0 20px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .list-details {
    border-top: 1px solid #f2f2f2;
  }

  .operate span {
    margin: 0 4px;
    color: #5087e4;
  }

  .w-40 {
    width: 40px !important;
  }

  .w-20 {
    width: 20% !important;
  }

  .list-details:last-child {
    border-bottom: 1px solid #f2f2f2;
  }

  .exportLog-btn {
    background: #5087e4 !important;
    color: #fff;
    padding: 7.5px 20px !important;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    float: right;
    margin-right: 20px;
  }

  .title {
    text-align: left;
    font-size: 14px;
  }

  .content {
    position: absolute;
    left: 329px;
    right: 0;
    bottom: 0;
    top: 0;
  }

  .top {
    margin-top: 20px;
  }

  .table-box {
    width: calc(100% - 20px);
    position: absolute;
    top: 60px;
    min-height: 776px;
    bottom: 20px;
    background: #fff;
    padding: 25px 0 0 20px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/Energy/RatioReport.vue